import React from "react";
import Carousel from "react-material-ui-carousel";
import { Typography, Box } from "@mui/material";

const testimonies = [
  {
    name: "Mr. Pinakin Shah",
    location: "",
    comment:
      "We are extremely happy with the final outcome. The home has turned out truly beautiful and continues to receive genuine appreciation from everyone who visits. Credit to the team for delivering such a refined result.",
  },
  {
    name: "Mr. Yash",
    location: "",
    comment:
      "From the bottom of our hearts, thank you. You helped us shape our very first home, and that is something we will always remember with warmth and gratitude.",
  },
  {
    name: "Mrs. Swati Mate",
    location: "",
    comment:
      "The house has been receiving endless compliments, all thanks to you and your team. The appreciation for your work has been overwhelming. Thank you once again.",
  },
  {
    name: "Mr. Heramb Tadpatrikar",
    location: "",
    comment:
      "The transformation of my restaurant exceeded every expectation. From understanding my vision to translating it into a space that is both striking and highly functional, the attention to detail was exceptional. The layout has significantly improved daily operations, enhancing the experience for both staff and guests. The entire process was seamless, professional, and collaborative. I look forward to working together again and wholeheartedly recommend their work.",
  },
  {
    name: "Mr. Arun Upadhyay",
    location: "",
    comment:
      "Thank you for turning our house into a true home. Your ability to balance ideas and execution, while thoughtfully addressing the needs of seniors, children, and the younger generation under one roof, was remarkable. Your guidance and suggestions made a meaningful difference, and we feel truly fortunate to have worked with you.",
  },
  {
    name: "Mrs. Rohini Malpani",
    location: "",
    comment:
      "Thank you for creating such a beautiful home for us. We couldn’t have asked for more.",
  },
  {
    name: "Mr. Sid",
    location: "",
    comment:
      "The house was loved by everyone. The entire experience went smoothly, and we genuinely enjoyed working with the team.",
  },
  {
    name: "Mr. Pratik Thakkar",
    location: "",
    comment:
      "My first home was designed by them, and I couldn’t be prouder. Having known them personally for years, it was special to see their talent translate into a space I truly love.",
  },
  {
    name: "Ms. Shreya Thaker",
    location: "",
    comment:
      "Their strength lies in doing less, but doing it perfectly. Thoughtful, perceptive, and deeply attentive to the people they design for, they carried the project with care from start to finish—addressing every requirement of both me and my parents. A truly seamless and rewarding experience.",
  },
];

const Testimony = ({ name, location, comment }) => {
  return (
    <Box sx={{ textAlign: "center", p: 2 }}>
      <Typography variant="h6" sx={{ mb: 1, fontFamily: "Avenir", fontWeight: "400", fontSize: "1em", color: "#121212" }}>
        {`\u201C${comment}\u201D`}
      </Typography>
      <Typography variant="subtitle1" fontWeight="bold" color="#4B4A4A" sx={{ fontSize: "0.9em" }}>
        {name}
      </Typography>
      <Typography variant="subtitle2" color="text.secondary" sx={{ fontSize: "0.8em" }}>
        {location}
      </Typography>
    </Box>
  );
};

const Testimonials = () => {
  return (
    <Box sx={{ textAlign: "center", p: 2 }}>
      <Typography variant="h5" gutterBottom fontFamily={"Audrey"} color="#535355">
        TESTIMONIALS
      </Typography>
      <Carousel
        autoPlay={true}
        interval={6000}
        animation="fade"
        indicators={false}
      >
        {testimonies.map((item, index) => (
          <Testimony
            key={index}
            name={item.name}
            location={item.location}
            comment={item.comment}
          />
        ))}
      </Carousel>
    </Box>
  );
};

export default Testimonials;
